import { classNameMerger } from '@breetometer/utils';

import type { ITablePlainProps } from './Table.helpers';

const TablePlain = <E extends { id: string }>({
	hideHeader = false,
	columns,
	data,
	rowClass,
	isLoading,
	skeletonRows,
}: ITablePlainProps<E>) => {
	const visibleColumns = columns.filter((column) => !column.hideColumn);
	return (
		<div className='table-plain-container scrollbar'>
			<table className='table-plain'>
				<thead className={classNameMerger(hideHeader && 'hidden')}>
					{isLoading ? (
						<tr>
							{Array.from({ length: visibleColumns.length }).map((_, index) => (
								<th
									scope='col'
									key={`table-plain-head-cell-skeleton-${String(index)}`}
								>
									<div
										className='global-skeleton'
										style={{ width: '100%' }}
									>
										loading...
									</div>
								</th>
							))}
						</tr>
					) : (
						<tr>
							{columns
								.filter((column) => !column.hideColumn)
								.map((column, index) => (
									<th
										scope='col'
										key={`table-plain-head-cell-${column.title}-${index}`}
									>
										{column.title}
									</th>
								))}
						</tr>
					)}
				</thead>
				<tbody>
					{isLoading
						? Array.from({ length: skeletonRows }).map((_, index) => (
								<tr
									key={`table-plain-body-row-skeleton-${String(index)}`}
									className={`table-plain-row ${rowClass ?? ''}`}
								>
									{Array.from({ length: visibleColumns.length }).map((__, colIndex) => (
										<td key={`table-plain-body-cell-skeleton-${String(index)}-${String(colIndex)}`}>
											<div
												className='global-skeleton'
												style={{ width: '100%' }}
											>
												loading...
											</div>
										</td>
									))}
								</tr>
							))
						: data.map((dataItem) => (
								<tr
									key={`table-plain-body-row-${dataItem.id}`}
									className={classNameMerger('table-plain-row', rowClass)}
								>
									{columns
										.filter((column) => !column.hideColumn)
										.map((column, index) => {
											const renderedValue = column.render ? column.render({ row: dataItem }) : column.value;
											return (
												<td
													key={`table-plain-body-cell-${column.title}-${index}`}
													className={column.className}
												>
													{renderedValue}
												</td>
											);
										})}
								</tr>
							))}
				</tbody>
			</table>
		</div>
	);
};

export default TablePlain;
